import script from "./FileExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./FileExplorer.vue?vue&type=script&setup=true&lang=js"

import "./FileExplorer.vue?vue&type=style&index=0&id=77aa72bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77aa72bc"]])

export default __exports__